import React, { createContext, useContext, useState, useEffect } from 'react';
import ClientAuthService from '../services/clientAuthService';

const ClientAuthContext = createContext();

export const useClientAuth = () => {
  const context = useContext(ClientAuthContext);
  if (!context) {
    throw new Error('useClientAuth must be used within a ClientAuthProvider');
  }
  return context;
};

export const ClientAuthProvider = ({ children }) => {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if client is already authenticated on app load
    const initAuth = async () => {
      try {
        if (ClientAuthService.isAuthenticated()) {
          const isValid = await ClientAuthService.verifyToken();
          if (isValid) {
            setClient(ClientAuthService.getCurrentClient());
          } else {
            ClientAuthService.clearAuth();
          }
        }
      } catch (error) {
        console.error('Client auth initialization error:', error);
        ClientAuthService.clearAuth();
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const result = await ClientAuthService.login(email, password);
      // console.log('Login result:', result);
      // alert("Login successful");
      setClient(result.client);
      return result;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    try {
      await ClientAuthService.logout();
    } catch (error) {
      console.error('Client logout error:', error);
    } finally {
      setClient(null);
    }
  };

  const value = {
    client,
    login,
    logout,
    isAuthenticated: !!client,
    loading
  };

  return <ClientAuthContext.Provider value={value}>{children}</ClientAuthContext.Provider>;
};